import React, { useState } from 'react';
import Pagination from './Pagination';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';

const universities = [
    {
        rank: 1,
        logo: "🏛️",
        name: 'University of Oxford',
        country: 'United Kingdom',
    },
    {
        rank: 2,
        logo: "🔬",
        name: 'Massachusetts Institute of Technology',
        country: 'United Kingdom',
    },
    {
        rank: 3,
        logo: "🎓",
        name: 'Harvard University',
        country: 'United States',
    },
    {
        rank: 4,
        logo: "🎓",
        name: 'Princeton University',
        country: 'United States',
    },
    {
        rank: 5,
        logo: "🎓",
        name: 'University of Cambridge',
        country: 'United Kingdom',
    },
    {
        rank: 6,
        logo: "🎓",
        name: 'Stanford University',
        country: 'United Kingdom',
    },
    {
        rank: 7,
        logo: "🎓",
        name: 'California Institute of Technology',
        country: 'United States',
    },
    {
        rank: 8,
        logo: "🎓",
        name: 'University of California - Berkeley',
        country: 'United States',
    },
    {
        rank: 9,
        logo: "🎓",
        name: 'Imperial College London',
        country: 'United Kingdom',
    },
    {
        rank: 10,
        logo: "🎓",
        name: 'Yale University',
        country: 'United States',
    },
];

interface BannerProps {
    apiValues: any;
    totalItems: any
}



const UniversityRankingList: React.FC<BannerProps> = ({ apiValues, totalItems }) => {


    return (
        <>
            <div className="bg-white p-6 rounded-md shadow-sm">
                <h2 className="text-lg font-semibold mb-4">
                    {totalItems} Universities, showing {apiValues.length == 0 ? 0 : `1 - ${apiValues.length}`} below
                </h2>

                <div className="flex flex-col space-y-4">
                    {/* {universities.map((univ) => ( */}

                    {

                        (Array.isArray(apiValues) ? apiValues : []).map((univ: any, index: number) => {

                            return (
                                <div
                                    key={univ.rankingNumber}
                                    className="flex flex-col sm:flex-row sm:items-center items-center bg-gray-50 rounded-md hover:shadow transition"
                                >
                                    {/* Rank */}
                                    <div className="w-10 h-16 rounded-md bg-red-600 flex items-center justify-center text-white font-bold text-sm mr-4">
                                        {univ.rankingNumber}
                                    </div>

                                    {/* University Logo */}
                                    <div className='flex-shrink-0 w-16 h-16 rounded-md flex items-center justify-center text-2xl mr-4 sm:mr-6'>
                                        <ImageWithBasePath
                                            // className="rounded-circle"
                                            source={univ?.imageUrl}
                                            alt="img"
                                        />
                                    </div>

                                    {/* Name & Country */}
                                    <div className="flex-1 text-center lg:text-left px-3 py-2 lg:px-0 lg:pl-3">
                                        <p className="text-base font-semibold text-gray-900 mb-1">{univ.title}</p>
                                        <p className="text-sm text-gray-500">{univ?.parentId?.countryName}</p>
                                    </div>


                                    {/* Arrow */}
                                    <div className="text-gray-900 text-lg font-bold mt-2 sm:mt-0 sm:mr-3 sm:ml-auto text-center sm:text-right">
                                        ›
                                    </div>
                                </div>
                            )

                        }) || []

                    }
                </div>
            </div>

            {/* <div className="flex flex-col justify-end items-end p-4">
                <Pagination />
            </div> */}
        </>

    );
};

export default UniversityRankingList;

